import {AfterViewInit, Component, signal, viewChild} from '@angular/core';
import {Subscription} from "rxjs";
import {FormBuilder, Validators} from "@angular/forms";
import {TextBoxComponent} from "@progress/kendo-angular-inputs";
import {Router} from "@angular/router";
import {NotificationService} from "@progress/kendo-angular-notification";
import {SessionService} from "../../../core/services/session.service";
import {showNotification} from "../../../shared/utilities/notificaton.util";


@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    standalone: false
})
export class LoginComponent implements AfterViewInit {
  public readonly textbox = viewChild<TextBoxComponent>('password');
  public loading = signal(false);
  public loadingMessage = signal('Logging In...');
  // public loggingIn: Subscription | any;
  public visible = 'password';
  public type = 'password';
  public loginForm = this.formBuilder.group({
    email: ['', [Validators.required]],
    password: ['', Validators.required]
  });
  constructor(public formBuilder: FormBuilder, private router: Router, private notificationService: NotificationService,
              private sessionService: SessionService) {
  }
  public ngAfterViewInit(): void {
    this.textbox()!.input.nativeElement.type = 'password';
  }
  async login() {
    console.log('login');
    const email = this.loginForm.get('email')?.value;
    const pass = this.loginForm.get('password')?.value;
    this.loading.set(true);
    this.loadingMessage.set('Logging In...');
    try {
      const res = await this.sessionService.login(email, pass);
      console.log(res);
      console.log('login res');
      console.log(res);
      if (res) {
        this.router.navigate(['/smart/formsList']);
      }
    } catch (err) {
      console.log("err: ", err);
      if (err.error != null) {
        if (err.error.message === 'Incorrect Password') {
          showNotification('Invalid Password, Try Again', 'error', this.notificationService);
        } else if (err.error.message === 'Email Not Found') {
          showNotification('Username Not Found, Try Again', 'error', this.notificationService);
        } else if (err.error.message === 'User is not active') {
          showNotification('Inactive Account', 'error', this.notificationService);
        } else if (err.error.message === 'User not authorized') {
          showNotification('This account is not authorized, Try Again', 'error', this.notificationService);
        } else {
          showNotification('An Error Occurred, please try again.', 'error', this.notificationService);
        }
      }
    } finally {
        this.loading.set(false);
    }
    // this.sessionService.login(email, pass).subscribe({
    //   next: (res) => {
    //     this.router.navigate(['/smart/formsList']);
    //     // this.loggingIn?.unsubscribe();
    //   },
    //   error: (err) => {
    //     console.log("err: ");
    //     console.log(err);
    //     // this.loggingIn?.unsubscribe();
    //     if (err.error != null) {
    //       if (err.error.message === 'Incorrect Password') {
    //         showNotification('Invalid Password, Try Again', 'error', this.notificationService);
    //       } else if (err.error.message === 'Email Not Found') {
    //         showNotification('Username Not Found, Try Again', 'error', this.notificationService);
    //       } else if (err.error.message === 'User is not active') {
    //         showNotification('Inactive Account', 'error', this.notificationService);
    //       } else if (err.error.message === 'User not authorized') {
    //         showNotification('This account is not authorized, Try Again', 'error', this.notificationService);
    //       } else {
    //         showNotification('An Error Occurred, please try again.', 'error', this.notificationService);
    //       }
    //     } else {
    //       showNotification('An Error Occurred, please try again.', 'error', this.notificationService);
    //     }
    //   }
    // });
  }

  public toggleVisibility() {
    const inputEl = this.textbox()?.input.nativeElement;
    inputEl.type = inputEl.type === 'password' ? 'text' : 'password';
    this.visible = inputEl.type;
  }
}
